export const CART_REQUEST = "CART_REQUEST";

export const CART_SUCCESS = "CART_SUCCESS";

export const CART_FAILURE = "CART_FAILURE";

export const GET_PRODUCTS_DATA = "GET_PRODUCTS_DATA";

export const GET_PRODUCTS_LOADING = "GET_PRODUCTS_LOADING";

export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";

export const UPDATE_QUANTITY = "UPDATE_QUANTITY";

export const REMOVE_FROM_CART = "REMOVE_FROM_CART";

export const SORT_ASC = "SORT_ASC";

export const SORT_DESC = "SORT_DESC";
